export const getMenuItems = () => {
  return [
    { key: "1", label: "Mais Informações" },
    { key: "2", label: "Anotações" },
    { key: "3", label: "Alterar Status" },
    { key: "4", label: "Andamentos" },
    { key: "5", label: "Excluir" },
    { key: "6", label: "Condições de pagamento" },
    { key: "7", label: "Enviar proposta" },
  ];
};

export const getMenuItemsProcura = () => {
  return [{ key: "1", label: "Mais Informações" }];
};
